export const normalizeOgRoutePath = (path = '/') => {
  const cleanPath = path.split(/[?#]/, 1)[0]?.trim() || '/';
  const withLeadingSlash = cleanPath.startsWith('/') ? cleanPath : `/${cleanPath}`;
  return withLeadingSlash === '/' ? '/' : withLeadingSlash.replace(/\/+$/, '');
};

export const ogImageFilenameForRoute = (path = '/') => {
  const normalizedPath = normalizeOgRoutePath(path);
  if (normalizedPath === '/') return 'workspace369-og-2026.jpg';

  const slug = normalizedPath
    .slice(1)
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '');

  return `page-${slug}-2026.jpg`;
};

export const ogImagePathForRoute = (path = '/') => {
  const filename = ogImageFilenameForRoute(path);
  return path === '/' || filename === 'workspace369-og-2026.jpg'
    ? `/images/${filename}`
    : `/images/og/${filename}`;
};
